export const createTiersRequests = (client) => ({
    listTiers: async (params) => {
        const { data, meta, links } = await client.api.get("tiers", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map